import React from 'react'

import { Link } from 'gatsby'
import { Container, Row, Col, Button } from 'react-bootstrap'
import NewsletterModal from "../NewsletterForm/NewsletterModal"
import ContactModal from "../ContactForm/ContactModal"
import '@fortawesome/fontawesome-svg-core/styles.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInstagramSquare, faFacebookSquare, faTwitterSquare } from '@fortawesome/free-brands-svg-icons'
import './footer.css'
import FooterLogo from '../../images/tvtap-header-logo.svg'

function Modal() {
    const [modalShow, setModalShow] = React.useState(false)
    return (
      <>
        <Button
          className="btn-block btn btn-action btn-sm home-btn"
          onClick={() => setModalShow(true)}
        >
          Newsletter Signup
        </Button>
  
        <NewsletterModal show={modalShow} onHide={() => setModalShow(false)} />
      </>
    )
  }

function ContactModalPopup() {
    const [modalShow, setModalShow] = React.useState(false)

    return (
        <>
          <Button 
            className="btn-block btn btn-action btn-sm home-btn"
            onClick={() => setModalShow(true)}
            >Send Us A Message
            </Button>
            <ContactModal show={modalShow} onHide={() => setModalShow(false)} />
        </>
    )
}

const Footer = () => {
    return (
        <>
        <footer className="footer">
            <Container className="container-fluid">
                <Row className="pt-4">
                    <Col sm={3} className="mb-4">
                        <Row className="text-center">
                            <Col>
                            <a href="https://www.instagram.com/tvtapidaho/" target="_blank" role="icon" aria-label="Teton Valley Trails &amp; Pathways on Instagram" title="Teton Valley Trails &amp; Pathways on Instagram">
                                <FontAwesomeIcon icon={faInstagramSquare} className="social-icon" aria-hidden="true"/>
                            </a>
                            </Col>
                            <Col>
                            <a href="http://www.facebook.com/pages/Teton-Valley-Trails-and-Pathways/50791241522" target="_blank" role="icon" aria-label="Teton Valley Trails &amp; Pathways on Facebook" title="Teton Valley Trails &amp; Pathways on Facebook">
                                <FontAwesomeIcon icon={faFacebookSquare} className="social-icon" aria-hidden="true"/>
                            </a>
                            </Col>
                            <Col>
                            <a href="https://twitter.com/TVTAP" target="_blank" role="icon" aria-label="Teton Valley Trails &amp; Pathways on Twitter" title="Teton Valley Trails &amp; Pathways on Twitter">
                                <FontAwesomeIcon icon={faTwitterSquare} className="social-icon" aria-hidden="true"/>
                            </a>
                            </Col>
                        </Row>
                    
                    </Col>
                    <Col sm={3} className="mb-4">
        <Modal />
        <ContactModalPopup />
                    </Col>
                    <Col sm={3} className="text-center">
                       <p className="footer-text"><span style={{fontFamily: 'Pifont-Bold, sans-serif', fontSize: '1.25rem', marginBottom: '10px'}}>Teton Valley Trails &amp; Pathways</span></p>
                       <p className="footer-text"><strong>Phone:</strong> 208-201-1622<br/>P.O. Box 373, Driggs, ID 83422<br/>
                       
                       </p>
                       
                    </Col>
                    <Col sm={3} className="text-center text-right-md">
                        <Link to="/"><img src={ FooterLogo } style={{width: '100px'}} alt="TVTAP Logo" /></Link>
                    </Col>
                </Row>
            </Container>
            <Container className="container-fluid">
        <Row>
                <Col>
                    <p className="footer-text pt-2 text-center" style={{fontSize: 'smaller', color: '#D6D6B4' }}>© {new Date().getFullYear()}, Teton Valley Trails &amp; Pathways | Website by <a href="https://inlightwebstudio.com" target="_blank" rel="nofollow noopener" style={{color: 'white'}}>Inlight Web Studio</a></p>
                </Col>
            </Row>
        </Container>
        </footer>
        </>
    )
}

export default Footer